import { GetDetailedInventoryPrediction } from "api/api.service"
import { DataTable } from "components/DataTable"
import { Modal } from "components/Modal"
import { useLocalPaginatedRequest } from "hooks/useLocalPaginatedRequest"
import AddNewItemForm from "pages/Common/InvManagementItemsTab/AddNewItemForm"
import React, { useState } from "react"
import { Card } from "reactstrap"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import { getInventoryWarningColor } from "./ProductionSchedule.utils"

const DATA_KEY = "predictions"
export const MAJOR_SHORTAGE_COLOR = "#E35050"
export const MINOR_SHORTAGE_COLOR = "#F6B93B"

const COLUMNS = {
   SKU_NO: "SKU No.",
   ITEMS_NAME: "Items Name",
   DEPARTMENT: "Department",
   DATE_OF_SHORTAGE: "Date of Shortage",
   QUANTITY_REMAINING: "Qty Remaining",
   DETAILS: "Details",
}

const InventoryWarningModal = props => {
   const { isOpen, toggleFunction, productionLineId } = props

   const [itemDes, setItemDes] = useState(null)
   const [showItemDesModal, setShowItemDesModal] = useState(false)

   const { data, isFetching } = useLocalPaginatedRequest({
      requestFn: GetDetailedInventoryPrediction,
      dataKey: DATA_KEY,
      params: {
         productionLineId,
      },
   })

   const handleCloseModal = () => {
      setItemDes(null)
      setShowItemDesModal(false)
   }

   const formConfig = [
      {
         title: COLUMNS.SKU_NO,
         render: data => <div className="fw-bold">{data?.skuNo ?? "-"}</div>,
      },
      {
         title: COLUMNS.ITEMS_NAME,
         render: data => data?.itemName ?? "-",
      },
      {
         title: COLUMNS.DEPARTMENT,
         render: data => data?.departmentName ?? "-",
      },
      {
         title: COLUMNS.DATE_OF_SHORTAGE,
         render: data =>
            convertDateTime({
               date: data.shortageDate,
               customFormat: dateTimeFormat.americanFormat,
               dateOnly: true,
            }),
      },
      {
         title: COLUMNS.QUANTITY_REMAINING,
         render: data => (
            <div
               className="fw-bold"
               style={{
                  color: getInventoryWarningColor(
                     data?.quantityRemaining,
                     data?.minorThreshold,
                     data?.mediumThreshold
                  ),
               }}
            >
               {data?.quantityRemaining ?? "-"}
            </div>
         ),
      },
      {
         title: COLUMNS.DETAILS,
         render: data => (
            <div
               className="inventory-link"
               onClick={() => {
                  setItemDes({ ...data, id: data?.itemId })
                  setShowItemDesModal(true)
               }}
            >
               See Inventory Details
            </div>
         ),
      },
   ]
   return (
      <Modal
         isOpen={isOpen}
         handleModalToggling={() => {
            toggleFunction(prev => !prev)
         }}
         bodyClassName="p-0"
         customButton={true}
         hideModalHeaderSeparator={true}
         headerClasses="header-container"
         fullscreen={"sm"}
         size="xl"
         backdrop="static"
         modalTitle={`Inventory Warning`}
      >
         <Card className="mx-5">
            <div style={InventoryWarningStyles.legendContainer}>
               <span style={InventoryWarningStyles.legendItem}>
                  <span
                     style={{
                        ...InventoryWarningStyles.legendDot,
                        background: MAJOR_SHORTAGE_COLOR,
                     }}
                  ></span>
                  <span style={InventoryWarningStyles.legendText}>
                     Major Shortage
                  </span>
               </span>
               <span style={InventoryWarningStyles.legendItem}>
                  <span
                     style={{
                        ...InventoryWarningStyles.legendDot,
                        background: MINOR_SHORTAGE_COLOR,
                     }}
                  ></span>
                  <span style={InventoryWarningStyles.legendText}>
                     Re-order Point
                  </span>
               </span>
            </div>
            <DataTable
               data={data}
               tableClasses="trailer-management-table"
               className="table-responsive"
               loading={isFetching}
               config={formConfig}
            />
         </Card>

         <Modal
            isOpen={showItemDesModal}
            handleModalToggling={handleCloseModal}
            bodyClassName="p-0"
            customButton={true}
            hideModalHeaderSeparator={true}
            headerClasses="pb-0"
            className="inv-req-popup-viewdetails"
            sizeClasses="10"
         >
            <AddNewItemForm
               isNative
               isReadOnly
               modalCloseHandler={handleCloseModal}
               title={"Item Details"}
               data={itemDes}
            />
         </Modal>
      </Modal>
   )
}

const InventoryWarningStyles = {
   legendContainer: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: 16,
      marginBottom: "16px",
      padding: "5px",
   },
   legendItem: {
      display: "flex",
      alignItems: "center",
      gap: 4,
   },
   legendDot: {
      width: 16,
      height: 16,
      borderRadius: "2px",
      display: "inline-block",
   },
   legendText: {
      fontSize: 14,
      marginLeft: 4,
   },
}

export default InventoryWarningModal
